import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  useLocation
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faSignOutAlt,
  faSitemap,
  faCog,
  faCogs,
} from "@fortawesome/free-solid-svg-icons";

import Dashboard from "./Dashboard";
import SideMenu from "./SideMenu";
import LeadAdd from "./LeadAdd";
import TaskList from "./TaskList";
import TopHeader from "../layout/TopHeader";
import LeadDetails from "./LeadDetails";
import LeadEdit from "./LeadEdit";
import SubStageMaster from "./master/SubStage";
import DropReason from "./master/dropReason/Lists";


export default function Leads() {
  let match = useRouteMatch();
  let location = useLocation();
  const parts = location.pathname.split('/');
  console.log(parts);
  let urlArray = {
    'add':{'openMenu':'1', 'activeKey':'1-1'},
    'my-task':{'openMenu':'2', 'activeKey':'2-1'},
    'master':{'openMenu':'3', 'activeKey':'3-1'},
  };

  let openMenu = urlArray[parts[2]]?.openMenu ?? '1';
  let activeKey = urlArray[parts[2]]?.activeKey ?? '1-1';

  console.log(openMenu+' '+activeKey);

  return (
    <div>
      <TopHeader />
      <div className="masterContainer">
        <div className={window.location.pathname.includes("leads/view") ? "mt-4" : "masterClassMain mt-4"}>
          {window.location.pathname.includes("leads/view") ? null : <SideMenu openMenu={openMenu} activeKey={activeKey} />}

          <Switch>
            <Route path={`${match.path}/master/drop-reason`}>
              <DropReason />
            </Route>
            <Route path={`${match.path}/master/sub-stage`}>
              <SubStageMaster />
            </Route>
            <Route path={`${match.path}/my-task`}>
              <TaskList />
            </Route>
            <Route path={`${match.path}/edit/:id`}>
              <LeadEdit />
            </Route>
            <Route path={`${match.path}/view/:id`}>
              <LeadDetails />
            </Route>
            <Route path={`${match.path}/add`}>
              <LeadAdd />
            </Route>
            <Route path={`${match.path}`}>
              <Dashboard />
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
}
